const { width } = useWindowSize()

const isMobile = computed(() => width.value <= 768)

export const useIsMobile = () => isMobile
